/**
 * Rough JWT shape check (header.payload.signature).
 * Same rule as CON-12826 GrantAccess / ChannelGranted helpers.
 */
export default function isJwtLikeToken(token) {
	if (typeof token !== 'string' || !token.length) {
		return false;
	}

	const parts = token.split('.');
	return parts.length === 3 && parts.every((part) => !!part);
}
